import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { BaseUnit } from '../../../../../theming/baseUnitDefinition';

interface LinkHoverTrigger {
  ref: React.RefObject<HTMLElement>;
  index: number;
}

export type RegisterLinkWithSubMenu = (ref: React.RefObject<HTMLElement>, index: number) => void;
type GetHoverPlaceholders = () => React.ReactElement[];

type UseLinksWithSubMenuHover = (onHoverLink: (element: HTMLElement, index: number) => void, ulRef: React.RefObject<HTMLUListElement>, firstRowHeightInLargeScreen: number, baseUnit: BaseUnit) => [RegisterLinkWithSubMenu, GetHoverPlaceholders];

const initialState = [] as LinkHoverTrigger[];

const reducer = (state: LinkHoverTrigger[], action: { data: LinkHoverTrigger }) => {
  if (action && action.data) {
    return [...state, action.data];
  }

  return state;
};

export const useLinksWithSubMenuHover: UseLinksWithSubMenuHover = (onHoverLink, ulRef, firstRowHeightInLargeScreen, baseUnit) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const registerLinkWithSubMenu = (ref: React.RefObject<HTMLElement>, index: number) => {
    if (ref.current === null) return;

    if (!state.find(element => element.ref.current === ref.current)) {
      dispatch({ data: { ref, index } });
    }
  };

  const getHoverPlaceholders = () => {
    return state.filter(trigger => {
      const { ref } = trigger;
      if (!ref.current || !ulRef.current) return false;
      if (ref.current.getBoundingClientRect().top > ulRef.current.getBoundingClientRect().top) return false;
      return true;
    }).map((trigger, index) => {
      const { ref } = trigger;
      const rect = ref.current!.getBoundingClientRect();
      const { style } = StyleSheet.create({
        style: {
          position: 'absolute',
          width: `${rect.width + baseUnit}px`,
          height: `${firstRowHeightInLargeScreen * baseUnit}px`,
          top: `-${(firstRowHeightInLargeScreen * baseUnit) / 2}px`,
          left: `${rect.left - baseUnit / 2}px`,
          cursor: 'pointer',
        },
      });

      const linkActualIndex = state.find(element => element.ref === ref)!.index;

      return <div className={css(style)} key={index} onMouseEnter={() => onHoverLink(ref.current!, linkActualIndex)} />;
    });
  };

  return [registerLinkWithSubMenu, getHoverPlaceholders];
};
